module.exports = (__webpack_require__(2))(51);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/FolderModel.js from dll-reference girder_plugin_slicer_cli_web
// module id = 158
// module chunks = 0